import { createContext } from "react";

const authContext = createContext({ auth: false });

export default authContext;
